import React from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import Link from "next/link";
import styles from "../../styles/Home.module.css";
import Image from "next/image";
import {
  getCountryAlpha3Codes,
  getLanguageCodes,
} from "../../utils/countrydata";
import { getCountrylist1 } from "../../utils/apiFunctions";
import Footer from "../../utils/footer";
import StreamInfor from "../../utils/streamsInfo";
import Toggle from "../../utils/Toggle";
import LoadmoreOrLessText from "../../utils/LoadmoreOrLess";

const SingleCountryInformation = ({
  results,
  alpha3CodeNames,
  languagecodes,
  counrtyname,
}) => {
  const router = useRouter();

  const uniqueID = () => {
    return Math.floor(Math.random() * Date.now());
  };

  //======= Navigation functions =========;
  function handleWorlddata() {
    router.push("/worlddata");
  }
  //console.log(results);
  const { setIsopen } = Toggle();
  const handleClick = () => {
    setIsopen(true);
  };
  //== Filter function for recommended stations ==
  const { streamInfor } = StreamInfor();
  const populaData = streamInfor
    ? streamInfor.filter((name) => name.popular === true)
    : "";
  const popularSelected = populaData.slice(0, 7);

  //== function to seperate title with hyphens in hyperlinks ==
  const hyphenateTitle = (title) => {
    if (title) {
      return title.replaceAll(
        /[" "?/#|]/g,
        (value) => ({ " ": "-", "?": "", "/": "-", "#": "", "|": "" }[value])
      );
    }
  };
  // countrylist.map(({ name }) => console.log(name.common));
  //========= Function to return Alpha3Codes name ===========//
  const returnAlpha3CodeName = (code) => {
    let getcode = !(alpha3CodeNames && Object.keys(alpha3CodeNames).length)
      ? ""
      : alpha3CodeNames.filter(({ alpha3Code }) => alpha3Code === code);
    if (getcode) {
      return getcode.map(({ countryname }) => countryname)[0];
    }
  };
  //========= Function to return language name ===========//
  const returnLanguageName = (langcode) => {
    let getcode = !(languagecodes && Object.keys(languagecodes).length)
      ? ""
      : languagecodes.filter(({ alhpacode }) => alhpacode === langcode);
    if (getcode) {
      return getcode.map(({ languagename }) => languagename)[0];
    }
  };
  //========= demonym Card ===========//
  const demonymcard = !(
    results &&
    results[0].demonyms &&
    Object.keys(results[0].demonyms).length
  ) ? (
    ""
  ) : (
    <>
      <div className="hero__data-key">Demonym:</div>
      <div className="hero__data-value">
        {Object.values(results[0].demonyms).map(
          (demo, i) =>
            `${demo.f}${
              Object.values(results[0].demonyms).length - 1 === i ? "" : ", "
            }`
        )}
      </div>
    </>
  );
  //========= capital Card ===========//
  const capitalcard = !(results && results[0].capital) ? (
    ""
  ) : (
    <>
      {" "}
      <div className="hero__data-key">Capital:</div>
      <div className="hero__data-value">
        {results[0].capital.map(
          (city, i) =>
            ` ${city}${results[0].capital.length - 1 === i ? "" : ","}`
        )}
      </div>
    </>
  );
  //========= calling Card ===========//
  const callingcard = !(
    results &&
    results[0].idd &&
    Object.keys(results[0].idd).length
  ) ? (
    ""
  ) : (
    <div className="country-data__wrapper">
      <div className="country__data-key">Calling:</div>
      <div className="country__data-value">
        {Object.values(results[0].idd)[1].map(
          (num, i) =>
            `${Object.values(results[0].idd)[0]}${num}${
              Object.values(results[0].idd)[1].length - 1 === i ? "" : ", "
            }`
        )}
      </div>
    </div>
  );
  //========= domain Card ===========//
  const domaincard = !(results && results[0].tld) ? (
    ""
  ) : (
    <div className="country-data__wrapper">
      <div className="country__data-key">Domain:</div>
      <div className="country__data-value">
        {results[0].tld.map((dom, i) => {
          return (
            <span key={results[0].tld[i]}>{`${dom}${
              results[0].tld.length - 1 === i ? "" : ", "
            }`}</span>
          );
        })}
      </div>
    </div>
  );
  //========= ioc Card ===========//
  const ioccard = !(results && results[0].cioc && results[0].cioc) ? (
    ""
  ) : (
    <div className="country-data__wrapper">
      <div className="country__data-key">IOC:</div>
      <div className="country__data-value">{results[0].cioc}</div>
    </div>
  );
  //========= fifa Card ===========//
  const fifacard = !(results && results[0].fifa) ? (
    ""
  ) : (
    <div className="country-data__wrapper">
      <div className="country__data-key">FIFA:</div>
      <div className="country__data-value">{results[0].fifa}</div>
    </div>
  );
  //========= region Card ===========//
  const regioncard = !(results && results[0].region) ? (
    ""
  ) : (
    <>
      <div className="hero__data-key">Continent:</div>
      <div className="hero__data-value">{results[0].region}</div>
    </>
  );
  //========= subregion Card ===========//
  const subregioncard = !(results && results[0].subregion) ? (
    ""
  ) : (
    <>
      <div className="hero__data-key">Sub Region:</div>
      <div className="hero__data-value">{results[0].subregion}</div>
    </>
  );
  //========= area Card ===========//
  const areacard = !(results && results[0].area) ? (
    ""
  ) : (
    <>
      <div className="hero__data-key">Surface Area:</div>
      <div className="hero__data-value">
        {new Intl.NumberFormat().format(results[0].area)} km²
      </div>
    </>
  );
  //========= population Card ===========//
  const populationcard = !(results && results[0].population) ? (
    ""
  ) : (
    <>
      <div className="hero__data-key">Population:</div>
      <div className="hero__data-value">
        {new Intl.NumberFormat().format(results[0].population)}
      </div>
    </>
  );
  //========= language Card ===========//
  const languagecard = !(
    results &&
    results[0].languages &&
    Object.keys(results[0].languages).length
  ) ? (
    ""
  ) : (
    <>
      <div className="hero__data-key">Language:</div>
      <div className="hero__data-value">
        {Object.values(results[0].languages).map(
          (lang, i) =>
            ` ${lang}${
              Object.values(results[0].languages).length - 1 === i ? "" : ","
            }`
        )}
      </div>
    </>
  );
  //========= currency Card ===========//
  const currencycard = !(
    results &&
    results[0].currencies &&
    Object.keys(results[0].currencies).length
  ) ? (
    ""
  ) : (
    <>
      <div className="hero__data-key">Currency:</div>
      <div className="hero__data-value">
        {Object.values(results[0].currencies).map(
          (currency, i) =>
            ` ${currency.name} (${currency.symbol})${
              Object.values(results[0].currencies).length - 1 === i ? "" : ","
            }`
        )}
      </div>
    </>
  );
  //========= currencyiso Card ===========//
  const currencyisocard = !(
    results &&
    results[0].currencies &&
    Object.keys(results[0].currencies).length
  ) ? (
    ""
  ) : (
    <div className="country-data__wrapper">
      <div className="country__data-key">ISO 4217 currency:</div>
      <div className="country__data-value">
        {Object.keys(results[0].currencies).map(
          (currency, i) =>
            `${currency} ${
              Object.values(results[0].currencies).length - 1 === i ? "" : ","
            }`
        )}
      </div>
    </div>
  );
  //========= coatofarms Card ===========//
  const coatofarmscard = !(
    results &&
    results[0].currencies &&
    Object.keys(results[0].coatOfArms).length
  ) ? (
    ""
  ) : (
    <div className="hero-coat">
      <Image
        src={results[0].coatOfArms.svg}
        alt="coat of arms"
        fill
        // layout="responsive"
        // width={100}
        // height="100px"
        priority={true}
      />
    </div>
  );
  //========= language Translations Card ===========//
  const languageTranslationsCard =
    results !== undefined && results !== "" ? (
      <div className="countrylist-card__data">
        <p className="countrylist-card__heading">Name in Other Languages</p>
        <LoadmoreOrLessText
          text={
            results[0].translations ? (
              <>
                {Object.entries(results[0].translations).map((lang, i) => {
                  return (
                    <div key={uniqueID()}>
                      <p
                        style={{
                          textTransform: "uppercase",
                          fontWeight: "bold",
                        }}
                      >
                        {lang[0] &&
                        returnLanguageName(lang[0]) !== undefined ? (
                          <span>{returnLanguageName(lang[0])} </span>
                        ) : (
                          ""
                        )}
                        ({lang[0]})
                      </p>
                      <div className="country-data__wrapper">
                        <span className="country__data-key">Common:</span>
                        <span className="country__data-value">
                          {lang[1].common}
                        </span>
                      </div>
                      <div className="country-data__wrapper">
                        <span className="country__data-key">Official:</span>
                        <span className="country__data-value">
                          {lang[1].official}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              ""
            )
          }
        />
      </div>
    ) : (
      ""
    );
  //========= others Card ===========//
  const othersCard =
    results !== undefined && results !== "" ? (
      <div className="countrylist-card__data">
        {results[0].borders ? (
          <p className="countrylist-card__heading">
            Neighbouring{" "}
            {results[0].borders.length > 1 ? (
              <span>Countries</span>
            ) : (
              <span>Country</span>
            )}
          </p>
        ) : (
          ""
        )}
        <LoadmoreOrLessText
          text={
            <>
              {results[0].borders ? (
                <>
                  {results[0].borders.map((bord, i) => (
                    <Link
                      key={uniqueID()}
                      href={`/country/${hyphenateTitle(
                        returnAlpha3CodeName(bord)
                      )}`}
                      legacyBehavior
                    >
                      <a className="countrylink">
                        {`${returnAlpha3CodeName(bord)}${
                          results[0].borders.length - 1 === i ? "" : ", "
                        }`}
                      </a>
                    </Link>
                  ))}
                </>
              ) : (
                ""
              )}
              {results[0].latlng ? (
                <p className="countrylist-card__heading">
                  Latitude And Longitude
                </p>
              ) : (
                ""
              )}
              {results[0].latlng ? (
                <>
                  {results[0].latlng.map(
                    (lat, i) =>
                      `${lat}${results[0].latlng.length - 1 === i ? "" : ", "}`
                  )}
                </>
              ) : (
                ""
              )}
              {results[0].timezones ? (
                <p className="countrylist-card__heading">Timezones</p>
              ) : (
                ""
              )}
              {results[0].timezones ? (
                <>
                  {results[0].timezones.map(
                    (time, i) =>
                      `${time}${
                        results[0].timezones.length - 1 === i ? "" : ", "
                      }`
                  )}
                </>
              ) : (
                ""
              )}
              {results[0].car ? (
                <p className="countrylist-card__heading">Car Information</p>
              ) : (
                ""
              )}
              {results[0].car ? (
                <div className="country-data__wrapper">
                  <div className="country__data-key">Driving Side:</div>
                  <div
                    className="country__data-value"
                    style={{ textTransform: "capitalize" }}
                  >
                    {results[0].car.side}
                  </div>
                  {results[0].car.signs !== undefined ? (
                    <div className="country__data-key">
                      Driving Sign
                      {results[0].car.signs.length > 1 ? <span>s</span> : ""}:
                    </div>
                  ) : (
                    ""
                  )}

                  {results[0].car.signs !== undefined ? (
                    <div className="country__data-value">
                      {results[0].car.signs.map(
                        (sign, i) =>
                          `${sign}${
                            results[0].car.signs.length - 1 === i ? "" : ","
                          }`
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
              {results && results[0].altSpellings.length > 0 ? (
                <p className="countrylist-card__heading">Popular Names</p>
              ) : (
                ""
              )}
              {results && results[0].altSpellings.length > 0 ? (
                <>
                  {results[0].altSpellings.map(
                    (lat, i) =>
                      `${lat}${
                        results[0].altSpellings.length - 1 === i ? "" : ", "
                      }`
                  )}
                </>
              ) : (
                ""
              )}
            </>
          }
        />
      </div>
    ) : (
      ""
    );
  //========= codes Card ===========//
  const codesCard =
    results !== undefined && results !== "" ? (
      <div className="countrylist-card__data">
        <p className="countrylist-card__heading">Codes</p>
        <LoadmoreOrLessText
          text={
            <>
              {results[0].cca2 ? (
                <div className="country-data__wrapper">
                  <div className="country__data-key">ISO 3166-1 alpha-2:</div>
                  <div className="country__data-value">{results[0].cca2}</div>
                </div>
              ) : (
                ""
              )}
              {results[0].cca3 ? (
                <div className="country-data__wrapper">
                  <div className="country__data-key">ISO 3166-1 alpha-3:</div>
                  <div className="country__data-value">{results[0].cca3}</div>
                </div>
              ) : (
                ""
              )}
              {results[0].ccn3 ? (
                <div className="country-data__wrapper">
                  <div className="country__data-key">ISO 3166-1 numeric:</div>
                  <div className="country__data-value">{results[0].ccn3}</div>
                </div>
              ) : (
                ""
              )}
              {currencyisocard}
              {ioccard}
              {fifacard}
              {domaincard}
              {callingcard}
            </>
          }
        />
      </div>
    ) : (
      ""
    );

  return (
    <main className={styles.main}>
      <div
        style={{
          width: "100%",
        }}
      >
        <div
          className={styles.grid}
          style={{ margin: "auto", animation: "fade 0,5s" }}
        >
          <Head>
            <title>{`${counrtyname} | radiobruce.com`}</title>
            <meta
              name="description"
              content="database on all countries in the world."
            />
            <meta
              name="keywords"
              content="listen to radio from ghana, radio ghana, ghana radio stations online, live radio ghana, live radio stream ghana, radiobruce, name, genre, location, radioBruce, radio bruce, radiobruce, alliance francaise de takoradi, alliance francaise, world country data, currency, population, language, ISO 3166-1 alpha-2, ISO 3166-1 alpha-3, latitude and longitude, borders, car signs, United Nations, restcountries, coat of arms, demonym"
            />
            <meta name="og:site_name" content="radiobruce.com" />
            <meta
              name="og:url"
              content={`https://www.radiobruce.com/country/${counrtyname}`}
            />
            <meta name="og:title" content={counrtyname} />
            <meta
              name="og:description"
              content={`Information on ${counrtyname}`}
            />
            <meta name="og:type" content="website" />
            <link rel="icon" href="/favicon.ico" />
          </Head>

          {results !== undefined && results !== "" ? (
            <div className="hero hero-country">
              <div className="hero-content">
                <div className="hero__title-flag">
                  <div className="hero-title">
                    {results && <h1>{results[0].name.common}</h1>}
                    <p>
                      {results && results[0].independent === true ? (
                        <span>An Independent Nation</span>
                      ) : (
                        <span>NOT an Independent Nation</span>
                      )}{" "}
                      and{" "}
                      {results && results[0].unMember === true ? (
                        <span>a member of the United Nations</span>
                      ) : (
                        <span>NOT a member of the United Nations</span>
                      )}
                    </p>
                  </div>
                  {results && results[0].flag ? (
                    <div className="hero-flag">{results[0].flag}</div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="hero__data-coat">
                  <div className="hero-data">
                    {results && results[0].name.official ? (
                      <>
                        <div className="hero__data-key">Official Name:</div>
                        <div className="hero__data-value">
                          {results[0].name.official}
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {demonymcard}
                    {capitalcard}
                    {regioncard}
                    {subregioncard}
                    {areacard}
                    {populationcard}
                    {languagecard}
                    {currencycard}
                  </div>
                  {coatofarmscard}
                </div>
              </div>
              <div
                className="hero-overley"
                // style={{
                //   backgroundImage: `url(${results[0].flags.svg})`,
                //   backgroundPosition: "cover cover",
                //   backgroundSize: "cover",
                //   backgroundRepeat: "no-repeat",
                // }}
              >
                {" "}
                <Image
                  src={results[0].flags.svg}
                  alt="worldmap"
                  fill
                  blurDataURL={blurDataURL}
                  placeholder="blur"
                  priority={true}
                />
              </div>
            </div>
          ) : (
            <h1>Loading... </h1>
          )}
          <div className="countrylist-container__data">
            {codesCard}
            {languageTranslationsCard}
            {othersCard}
          </div>

          <div
            style={{
              width: "100%",
              boxShadow: "10px 10px 14px 1px rgb(0 0 0 / 20%)",
            }}
          >
            <Footer popularSelected={popularSelected} />
          </div>
        </div>
      </div>
    </main>
  );
};

export default SingleCountryInformation;


export const getStaticPaths = async () => {
  try {
    // Directly call the function to fetch the country list
    const countrylist = await getCountrylist1();

    // Validate the data and ensure we have an array
    if (!Array.isArray(countrylist)) {
      console.warn("Invalid country list data:", countrylist);
      return {
        paths: [],
        fallback: true,
      };
    }

    // Filter out any invalid entries and ensure name is a string
    const paths = countrylist
      .filter((country) => country && typeof country.name === "string")
      .map(({ name }) => ({
        params: {
          countryname: name.toString(),
        },
      }));

    console.log(`Generated ${paths.length} valid paths`);

    return {
      paths,
      fallback: true,
    };
  } catch (error) {
    console.warn("Error fetching country list:", error);
    return {
      paths: [],
      fallback: true,
    };
  }
};

export const getStaticProps = async (context) => {
  const countrylist = await getCountrylist1();
  const alpha3CodeNames = await getCountryAlpha3Codes();
  const languagecodes = await getLanguageCodes();
  const pagename = context.params.name;

  const removeHyphenateTitle = (title) => {
    if (title) {
      if (title === "Timor-Leste" || title === "Guinea-Bissau") {
        return title;
      } else {
        return title.replaceAll(/[-]/g, (value) => ({ "-": " " }[value]));
      }
    }
  };
  
  //== function to return country of the moment ==
  function returnCountryOfTheMoment() {
    if (countrylist) {
      for (let j = 0; j < countrylist?.length; j++) {
        const countryofthemoment = countrylist[j];
        if (
          countryofthemoment.name.common.toLowerCase() ===
          removeHyphenateTitle(pagename).toLowerCase()
        ) {
          return [countryofthemoment];
        }
      }
    }
  }

  return {
    props: {
      countrylist: countrylist || null,
      alpha3CodeNames: alpha3CodeNames || null,
      languagecodes: languagecodes || null,
      counrtyname: returnCountryOfTheMoment()[0].name.common,
      results: returnCountryOfTheMoment() || null,
    },
    revalidate: 1000, // In seconds
  };
};

const blurDataURL =
  "data:image/webp;base64,UklGRrYAAABXRUJQVlA4TKkAAAAvHEAFAJkuRPQ/NlGE6H84HEeSGzdg/un6a+5nAZ8BDCTZIBCEiP+bYdC2jaA0xx/qQ/gsJuC2jxA+iNd/vMhzx/TSk/wEYdhKgomConnDYVxPNoXidDJ8xSXa/Sbrwi8SvsWkKW7s73Bs9wyCkZKnDvlSIlZerINKopH8Ks/sSlfGlVXon+n5u64ca1tdgwbMzim48JK7AqCihVVRCPjtEiDEBayMqlwFAA==";
